import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import LotteryCodeField from '../../components/LotteryCodeField';
import ScopeField from '../../components/ScopeField';
import ParameterDetailsView from './ParameterDetailsView';
import './SeeParametersPage.css';

// Rendu dynamique (2026-09-17) : le radio de portee et le select Day n'avaient
// jamais eu d'effet reel (ParameterDetailsView etait 100% mock) — retires.
// 2026-10-05 : portee Tout / Groupe / Banque REELLE (parametres effectifs de ce
// groupe / cette banque, cf. ProductConfigViewSet.list ?effective=1), et le
// formulaire reste affiche au-dessus des resultats pour enchainer les recherches.
const FILTERS = ['Tout', 'Groupe', 'Banque'];

const SeeParametersPage = () => {
  const [lottery, setLottery] = useState('1');
  const [lotteryName, setLotteryName] = useState('NY MIDI');
  const [filter, setFilter] = useState('Tout');
  const [scopeId, setScopeId] = useState('');
  const [scopeName, setScopeName] = useState('');
  const [scopeError, setScopeError] = useState('');
  // Criteres de la DERNIERE recherche (les resultats ne bougent pas pendant
  // qu'on modifie le formulaire, seulement au clic sur Search).
  const [search, setSearch] = useState(null);

  const handleFilterChange = (opt) => {
    setFilter(opt);
    setScopeId('');
    setScopeName('');
    setScopeError('');
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (filter !== 'Tout' && !scopeId) {
      setScopeError(`Choisis d'abord ${filter === 'Groupe' ? 'le groupe' : 'la banque'}.`);
      return;
    }
    setScopeError('');
    setSearch((prev) => ({
      lottery,
      lotteryName,
      group: filter === 'Groupe' ? scopeId : '',
      bank: filter === 'Banque' ? scopeId : '',
      scopeLabel: filter === 'Tout' ? '' : `${filter}: ${scopeName}`,
      key: (prev?.key || 0) + 1,
    }));
  };

  return (
    <Layout>
      <p className="sp-breadcrumb">
        Ruta : <Link to="/dashboard" className="bc-link">Menu</Link>
        {' >> '}
        <Link to="/central" className="bc-link">Central</Link>
        {' >> '}
        <span className="bc-current">See Parameters</span>
      </p>

      <div className="sp-card">
        <div className="sp-card-header">
          <span className="sp-card-title">Consultar Parametros</span>
        </div>
        <div className="sp-card-body">
          <form onSubmit={handleSearch} className="sp-form">
            <div className="sp-radio-row">
              {FILTERS.map((opt) => (
                <label key={opt} className="sp-radio-label">
                  <input
                    type="radio"
                    name="sp-filter"
                    value={opt}
                    checked={filter === opt}
                    onChange={() => handleFilterChange(opt)}
                  />
                  {opt}
                </label>
              ))}
            </div>

            {filter !== 'Tout' && (
              <div className="sp-row">
                <label className="sp-label">{filter}</label>
                <ScopeField
                  filter={filter}
                  id={scopeId}
                  name={scopeName}
                  onResolve={(id, nm) => { setScopeId(id); setScopeName(nm); setScopeError(''); }}
                  inputClass="sp-input sp-input-sm"
                  iconClass="sp-icon-btn"
                  nameClass="sp-lottery-name"
                  errClass="sp-error"
                />
              </div>
            )}

            <div className="sp-row">
              <label className="sp-label">Lottery</label>
              <LotteryCodeField
                value={lottery}
                name={lotteryName}
                onChange={(code) => { setLottery(code); setLotteryName(''); }}
                onResolve={(code, nm) => { setLottery(code); setLotteryName(nm); }}
                inputClass="sp-input sp-input-sm"
                iconClass="sp-icon-btn"
                nameClass="sp-lottery-name"
              />
            </div>

            {scopeError && <p className="sp-error">{scopeError}</p>}
            <button type="submit" className="sp-search-btn">Search</button>
          </form>
        </div>
      </div>

      {search && (
        <ParameterDetailsView
          embedded
          lottery={search.lottery}
          lotteryName={search.lotteryName}
          group={search.group}
          bank={search.bank}
          scopeLabel={search.scopeLabel}
          searchKey={search.key}
        />
      )}
    </Layout>
  );
};

export default SeeParametersPage;
